<section class="layout-franchise">
  <form #franchiseForm="ngForm" (ngSubmit)="manageFranchise(); $event.stopPropagation()" class="franchise-layout">
    <fieldset class="themeBranch1-contact">
      <div class="grid-franchise">
        <mat-form-field appearance="fill" class="w-full">
          <input
            id="name"
            name="name"
            ngModel
            placeholder="ชื่อ"
            [(ngModel)]="franchiseFormSignal().name"
            matInput
            required
            [pattern]="namePattern"
          />
          <mat-error>
            กรุณากรอก
            <strong>ชื่อ</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <input
            id="lastname"
            name="lastname"
            placeholder="นามสกุล"
            [(ngModel)]="franchiseFormSignal().lastname"
            matInput
            required
            [pattern]="namePattern"
          />
          <mat-error>
            กรุณากรอก
            <strong>นามสกุล</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <input
            id="tel"
            name="tel"
            type="tel"
            placeholder="เบอร์โทรศัพท์มือถือ"
            pattern="0[0-9]{8,9}"
            maxlength="10"
            [(ngModel)]="franchiseFormSignal().tel"
            matInput
            required
          />
          <mat-error>
            กรุณากรอก
            <strong>เบอร์โทร</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <input
            id="email"
            name="email"
            type="email"
            placeholder="อีเมล"
            [email]="true"
            [(ngModel)]="franchiseFormSignal().email"
            matInput
          />
          <mat-error>กรุณากรอกอีเมลให้ถูกต้อง</mat-error>
        </mat-form-field>
        <!-- Honeypot field - hidden from real users, bots will fill it -->
        <mat-form-field appearance="fill" class="hp-field" aria-hidden="true">
          <input
            type="text"
            id="website"
            name="website"
            placeholder="website"
            [(ngModel)]="franchiseFormSignal().website"
            tabindex="-1"
            autocomplete="off"
            matInput
          />
        </mat-form-field>
      </div>

      <div class="container-franchise-button">
        <button mat-flat-button class="themeContactButton1" type="submit">ส่งข้อมูล</button>

        <button mat-flat-button class="themeContactButton2" type="submit">ส่งข้อมูล</button>
      </div>

      @if (showMessageSuccess()) {
      <div class="messageAlert-layout">
        <span class="text-success text-alert">ข้อมูลของท่านถูกบันทึกแล้ว</span>
      </div>
      } @if (!showMessageSuccess() && franchiseFormSignal().pristine) {
      <div class="messageAlert-layout">
        <span class="text-fail text-alert">ข้อมูลของท่านถูกไม่ถูกต้อง</span>
      </div>
      }
    </fieldset>
  </form>
</section>
